<template>
  <form-item
    class="FormItem"
    :class="{ 'FormItem--noHelp': noHelp || (!help && !$slots.help) }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:label>
      <slot name="label"></slot>
    </template>
    <div class="FormItem-input">
      <slot></slot>
    </div>
    <template v-slot:error>
      <slot name="error"></slot>
    </template>
    <div
      v-if="!noHelp && (help || $slots.help)"
      class="FormItem-help"
      ref="help"
    >
      <!-- @slot Contenu de l'aide, remplace la propriété `help` si renseigné -->
      <slot name="help">{{ help }}</slot>
    </div>
  </form-item>
</template>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

.FormItem {
  @extend .pb-4, .mb-4;

  &.FormItem--noHelp {
    @extend .mb-0;
  }

  &-help {
    @extend .pt-2;
    color: $text-muted;
    font-size: $font-size-sm;
    left: 0;
    line-height: $font-size-sm;
    position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;
    top: 100%;
    width: 100%;
    white-space: nowrap;

    .FormItem.is-error & {
      display: none;
    }
  }
  &-input {
    clear: both;
    float: none;

    > :not(:last-child) {
      @extend .mr-4;
    }
  }
}
</style>

<script>
import { FormItem } from 'element-ui'

/**
 * Champ complet de formulaire.
 *
 * Étend le [composant Element FormItem](https://element.eleme.io/#/fr-FR/component/form).
 */
export default {
  name: 'ElFormItem',
  props: {
    /**
     * Texte d'aide.
     */
    help: String,
    /**
     * Forcer à ne pas afficher l'aide.
     */
    noHelp: { type: Boolean, default: false }
  },
  components: {
    FormItem
  },
  mounted () {
    this.setHelpTitle()
  },
  updated () {
    this.setHelpTitle()
  },
  methods: {
    setHelpTitle () {
      if (!this.$refs.help) return
      if (this.$refs.help.scrollWidth > this.$refs.help.offsetWidth) {
        this.$refs.help.title = this.$refs.help.innerText
      }
    }
  }
}
</script>

<docs>
### Exemples

```jsx
<el-form label-position="top">
  <el-form-item label="Label du champ" help="Texte d'aide">
    <div class="el-input"><input type="text" class="el-input__inner" /></div>
  </el-form-item>
</el-form>
```

```jsx
<el-form label-position="top">
  <el-form-item label="Label du champ">
    <div class="el-input"><input type="text" class="el-input__inner" /></div>
    <span slot="help">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer sodales ut tellus sed malesuada.
    Vivamus ornare egestas augue at sodales. Morbi aliquet interdum lectus at finibus.
    Nullam libero est, finibus venenatis eleifend non, blandit id nulla. Etiam tristique ipsum augue, mollis
    tempus libero congue ut. Morbi id risus euismod, faucibus magna eget, vehicula dui</span>
  </el-form-item>
</el-form>
```
</docs>
